import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";
import { LOGGED_HOME_PAGE_PATH } from "../../constants/env";
import type { HeaderStoreInterface } from "../stores/header";
import { HeaderStore } from "../stores/header";
import { getQueryParams } from "../utils/getQueryParams";

const pathWithBackToSections = ["sorry"];

const pathBacks = [
  {
    match: "",
    backTo: "",
  },
];

export function useHeaderCloseButton(): HeaderStoreInterface["closeButton"] {
  const header = useAtomValue(HeaderStore);
  const location = useLocation();

  const backParam = getQueryParams().get("back");

  if (backParam) return { ...header.closeButton, url: backParam };

  if (header.closeButton?.url === location.pathname) return { ...header.closeButton, url: LOGGED_HOME_PAGE_PATH };

  if (header.closeButton === undefined && pathWithBackToSections.some((x) => location.pathname.includes(x))) {
    return { url: "/profile" };
  }

  const { backTo } = pathBacks.find((x) => x.match === location.pathname) || {};
  if (backTo) return { ...header.closeButton, url: backTo };

  return header.closeButton;
}
